// extracted by mini-css-extract-plugin
export default {"iconTitleSidebar":"Title_iconTitleSidebar__pavwG","title__mdi__icon":"Title_title__mdi__icon__bmzok"};